
import React, { Component } from 'react';
import services from '../../../services';
import $, { data } from 'jquery'
import TlkTable from '../../../components/tlelrik/table/tlkTable';
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import { Grid, GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import ParcelVirsion from '../../../components/Parcel-Right-panel/ParcelVirsion';
import DropDownCell  from './myDropDownCell';
import { insertItem, getItems, updateItem, deleteItem , deleteAll} from "./services";
import { MyCommandCell } from "./MyCommandCell"
import { NumericCell } from './NumericText';
import { FormatMoney } from './FormatMoney';
import CriacaoReceita from './CriacaoReceita';
import { TextCell } from './TextCell';


const queryString = require('query-string');
var moment = require('moment')
const dateFormat = "DD-MM-YYYY";
const fullDateFormat = "DD-MM-YYYY HH:mm:ss";
let listdefaultRequest = { Filters: null, "SortBy": "id", "IsSortTypeDESC": true, "IsPagination": true, "Page": 1, "PageSize": 100 }
let today = new Date();
let current_date = moment(today).format(dateFormat);
today.setDate(today.getDate() - 7);
let LastWeek = moment(today).format(dateFormat);
var tableData = [];
today = new Date();
today.setDate(today.getDate() - 14);
let Last2Week = moment(LastWeek).format(dateFormat);
var OtherThis;
today = new Date();
today.setMonth(today.getMonth() - 1);
let Pastmonthdate = moment(today).format(dateFormat);
const editField = "inEdit"; 
let tablesjson = {
    "LinhasFatura": {
        columnkeyMap: {
            "idArtigo": "Artigo",
            "descricao": "Descrição",
            "quantidade": "Quantidade",
            "ValorUnitario": "Valor Unitário",
            "IVA": "IVA" ,
            "valor": "Total",
        },
        // actionbuttons: { 
        //     module: "Receita",  
        // },
        listApilink: "/Receita/GetFaturaLinhas",
        requestMethod: "get",
        notAction: false,
        //totalPageHeading : "Lista de pedidos para iniciar avaliação ",
        Filters: {
            //"IdFatura" : 0
        },
    },
}

class CriacaoFatura extends Component {
    /* Primeiro passo na acomodação da classe */

    editField = "inEdit";
    state = {
      data: []
    };

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        this.setState({
            data: getItems()
          });
         
        //tableData = []
        (async () => {
          OtherThis = this
            const datapagamento = {}
                const TipoPagamento = await services.apiCall.requestApi(
                   "/Receita/GetTipoPagamento",
                   datapagamento,
                   "get"
                );
                console.log(TipoPagamento)
                this.setState({
                    artigo: TipoPagamento               
                })

                console.log("QUERO SABER", this.state.artigo)
                console.log("QUERO SABER 2" ,tablesjson)
         })();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    // componentDidUpdate = (preProp) => {
    //     if (preProp.date !== this.props.date || preProp.tableName !== this.props.tableName) {
    //         console.log("update",this.props,preProp)
    //         this.defaultState();
    //     }
    // }


    /*  Para renderizar o conteúdo html da página   */
    CommandCell = props => (
        <MyCommandCell
          {...props}
          edit={this.enterEdit}
          remove={this.remove}
          add={this.add}
          discard={this.discard}
          update={this.update}
          cancel={this.cancel}
          editField={this.editField}
        />
      );

    remove = dataItem => {
      const data = deleteItem(dataItem)
      var total = 0
     
      for (let index = 0; index < data.length; index++) {
        var valor = data[index].valor;
        total += parseFloat(valor.replace(/\./g, '').replace(/\,/g, '.'));
        
      }
      var TotalFormated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(total)
      $(".Subtotal").text(String(TotalFormated))
      var countIva = 0
      for (let index = 0; index < data.length; index++) {
        var ivaTotal = data[index].idArtigo.value;
        var totalParaIva = parseFloat(data[index].valor.replace(/\./g, '').replace(/\,/g, '.'));
        
        ivaTotal = ivaTotal.split("!")[0]
        var count = (totalParaIva * ivaTotal) / 100
        countIva += count
    }
    var IvaFormated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(countIva)
    $(".IvaReceita").text(String(IvaFormated))

    var rec = parseFloat($(".IvaReceita").text().replace("€" , "").replace(/\./g, '').replace(/\,/g, '.')) + parseFloat($(".Subtotal").text().replace("€" , "").replace(/\./g, '').replace(/\,/g, '.'))
    var ReceitaFormated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(rec)
    
    $(".totalReceita").text(String(ReceitaFormated))
      this.setState({
        data
      });
    };
    
    add = dataItem => {
        $(".k-grid-container").css("border" ,"1px solid #00000014")
        dataItem.inEdit = true;
        var Total = document.getElementsByClassName("textBox")[0].value
  
        var total = 0
        // var totalParaIva = 0
        var ivaTotal;
        dataItem.valor = Total
        dataItem.ValorUnitario = $(".valorUnitarioFill").text()
        dataItem.iva = $(".ivaFill").text()
        dataItem.Descricao = $(".textBoxDescricao").text()
        if(dataItem.valor == ""){
           $(".quantidadeField").css("border" , "1px solid red")
        }else{
            $(".quantidadeField").css("border" , "1px solid #0000000f")  
        }
        
        if(dataItem.Descricao != "" && dataItem.ValorUnitario != "" && dataItem.valor != "" ){
            
            const data = insertItem(dataItem);
            this.setState({
                data: data
            });
        var countIva = 0
        
        data.map((data) => (
            total +=  parseFloat(data.valor.replace(/\./g, '').replace(/\,/g, '.'))
           
        ));
        var TotalFormated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(total)

        $(".Subtotal").text(String(TotalFormated))

        for (let index = 0; index < data.length; index++) {
            var ivaTotal = data[index].idArtigo.value;
            ivaTotal = ivaTotal.split("!")[0]
            var totalParaIva = parseFloat(data[index].valor.replace(/\./g, '').replace(/\,/g, '.'));;
            

            var count = (totalParaIva * ivaTotal) / 100
            countIva += count
        }
        var IvaFormated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(countIva)
        $(".IvaReceita").text(String(IvaFormated))
        var totalIva = parseFloat($(".IvaReceita").text().replace(/\./g, '').replace(/\,/g, '.')) + parseFloat($(".Subtotal").text().replace(/\./g, '').replace(/\,/g, '.'))
        var TotalIvaFormated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(totalIva)
        
        $(".totalReceita").text(String(TotalIvaFormated))
        
        
        tableData = data
    }
    };
    // add = dataItem => {
    //     dataItem.inEdit = true;
    
    //     const data = insertItem(dataItem);
    //     this.setState({
    //       data: data
    //     });
    //   };
    update = dataItem => {
      dataItem.inEdit = false;
     
      const data = updateItem(dataItem);
      var total = 0
     
      for (let index = 0; index < data.length; index++) {
        var valor = data[index].valor;
        total += parseFloat(valor.replace(/\./g, '').replace(/\,/g, '.'));
        
      }
      var TotalFormated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(total)
      $(".Subtotal").text(String(TotalFormated))
      var countIva = 0
      for (let index = 0; index < data.length; index++) {
        var ivaTotal = data[index].idArtigo.value;
        var totalParaIva = parseFloat(data[index].valor.replace(/\./g, '').replace(/\,/g, '.'));
        
        ivaTotal = ivaTotal.split("!")[0]
        var count = (totalParaIva * ivaTotal) / 100
        countIva += count
    }
    var IvaFormated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(countIva)
    $(".IvaReceita").text(String(IvaFormated))

    var rec = parseFloat($(".IvaReceita").text().replace("€" , "").replace(/\./g, '').replace(/\,/g, '.')) + parseFloat($(".Subtotal").text().replace("€" , "").replace(/\./g, '').replace(/\,/g, '.'))
    var ReceitaFormated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(rec)
    
    $(".totalReceita").text(String(ReceitaFormated))
      
      this.setState({
        data
      });
    }; // Local state operations
  
    discard = dataItem => {
      const data = [...this.state.data];
      data.splice(0, 1);
      this.setState({
        data
      });
    };
    cancel = dataItem => {
        const originalItem = getItems().find(
          p => p.ProductID === dataItem.ProductID
        );
        const data = this.state.data.map(item =>
          item.ProductID === originalItem.ProductID ? originalItem : item
        );
    
        this.setState({ data });
      };
    
      enterEdit = dataItem => {
        this.setState({
          data: this.state.data.map(item =>
            item.ProductID === dataItem.ProductID ? { ...item, inEdit: true } : item
          )
        });
      };
    itemChange = event => {
    
    var totalBox = document.getElementsByClassName("textBox")
    if(totalBox.length > 0){
        totalBox = document.getElementsByClassName("textBox")[0].value
    }
      const data = this.state.data.map(item => item.valor === event.dataItem.valor ? { ...item,
        [event.field || '']: event.value
      } : item);
      this.setState({
        data
      });
      if(event.dataItem != null){
        //var ValorUnitario =$(".valorUnitarioFill").text()
        if(event.field == "quantidade"){
          var Quantidade = event.value
        }else{
          var Quantidade = event.dataItem.quantidade
        }
        
        var ValorUnitario =  event.dataItem.ValorUnitario
        if(event.field == "idArtigo"){
            var valorTextIdArtigo = event.value.value.split("!")[2].replace("." , ",")
            var valorTextivaArtigo = event.value.value.split("!")[0].replace("." , ",")

            $(".valorUnitarioFill").text(valorTextIdArtigo)
            $(".valorUnitarioFill").val(valorTextIdArtigo)

            $(".ivaFill").text(valorTextivaArtigo)
            $(".ivaFill").val(valorTextivaArtigo)

            $(".textBoxDescricao").text(event.value.descricao)
            $(".textBoxDescricao").val(event.value.descricao)

            if(valorTextIdArtigo != undefined && Quantidade != undefined){
              const valorUnitario = parseFloat(valorTextIdArtigo.replace(/\./g, '').replace(/\,/g, '.'));
              Quantidade = parseFloat(Quantidade.replace(/\./g, '').replace(/\,/g, '.'));
  
              var Total = Quantidade * valorUnitario
              Total = Total.toFixed(2)
              var cenas = String(new Intl.NumberFormat('de-DE').format(parseFloat(Total)));
              $(".textBox").text(cenas)
              $(".textBox").val(cenas) 
          }
        }else{
          if(ValorUnitario != undefined && Quantidade != undefined){
            const valorUnitario = parseFloat(ValorUnitario.replace(/\./g, '').replace(/\,/g, '.'));
            Quantidade = parseFloat(Quantidade.replace(/\./g, '').replace(/\,/g, '.'));

            var Total = Quantidade * valorUnitario
            Total = Total.toFixed(2)
            var cenas = String(new Intl.NumberFormat('de-DE').format(parseFloat(Total)));
            $(".textBox").text(cenas)
            $(".textBox").val(cenas) 
        }
        }
        
      }
    };
    addNew = () => {
        if($('#tabelaNovaAdicionar .k-grid-save-command').length == 0){
            const newDataItem = {
                inEdit: true,
                Discontinued: false,
                valor: "",
                ValorUnitario: "",
                iva: "",
                descricao:""
              };
            
                this.setState({
                    data: [newDataItem, ...this.state.data]
                  });
            
        }
    };
    static removeAllrows = () => {
      OtherThis.refreshDS()
    }
    refreshDS = (remove) =>{

      this.setState({
          data: []
      })

     

      deleteAll();
  }
    // itemChange = event => {
    //     const data = this.state.data.map(item =>
    //       item.ProductID === event.dataItem.ProductID
    //         ? { ...item, [event.field]: event.value }
    //         : item
    //     );
    
    //     this.setState({ data });
    //   };
    
    //   addNew = () => {
    //     const newDataItem = { inEdit: true, Discontinued: false };
    
    //     this.setState({
    //       data: [newDataItem, ...this.state.data]
    //     });
    //   };
    render() {
        return (
            
        <div className="custom-k-grid table-section">
                <div className="table-responsive" id='tabelaNovaAdicionar'>     
                <Grid
                    style={{ height: "420px" }}
                    data={this.state.data}
                    onItemChange={this.itemChange}
                    editField={this.editField}
                >
                  <GridToolbar>
                    <button title="Add new" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary botaoAdicionarNovoEnable" id='botaoAdicionarNovo' onClick={this.addNew}>
                       + Adicionar Nova Linha da Fatura
                    </button>
                  </GridToolbar>
                  <Column field="ProductID" title="Linha" width="60px" editable={false} />
                  <Column field="idArtigo" title="Artigos" width="150px" cell={DropDownCell} />
                  <Column field="descricao" title="Descrição" cell={NumericCell}/>
                  <Column field="quantidade" title="Quantidade"  width="140px"cell={FormatMoney}/>
                  <Column field="ValorUnitario" title="Valor Unitário (€)" width="140px" cell={NumericCell} />
                  <Column field="iva" title="IVA (%)" width="140px" cell={NumericCell} />
                  <Column field="valor" title="Total (€)" cell={NumericCell} width="120px" />
                  <Column cell={this.CommandCell} width="90px" />
                  {/* <Column field="ProductID" title="Linha" width="60px" editable={false} />
                  <Column field="idArtigo" title="Artigos" width="150px" cell={DropDownCell}  />
                  <Column field="descricao" title="Descrição" />
                  <Column field="quantidade" title="Quantidade"  width="140px"/>
                  <Column field="ValorUnitario" title="Valor Unitário (€)" width="140px" />
                  <Column field="valor" title="Total (€)"  width="120px" />
                  <Column cell={this.CommandCell} width="90px" /> */}
                </Grid>
        
                </div>
        </div>
    )}
}

export default CriacaoFatura;